import { useMemo } from 'react';

import useTenantTranslation from '~/hooks/useTenantTranslation';

type MultilingualSearchableAttrConfig = {
  attr: string;
  multilingual: boolean;
};

const useMultilingualSearchableAttributes = (
  attributesConfig: MultilingualSearchableAttrConfig[],
) => {
  const { i18n } = useTenantTranslation();
  const { language } = i18n;

  const multilingualAttributes = useMemo(() => {
    const attrArr: string[] = [];
    attributesConfig.forEach((attribute) => {
      if (attribute.multilingual) {
        attrArr.push(`${attribute.attr}.${language}`);
        if (language !== 'en') {
          attrArr.push(`${attribute.attr}.en`);
        }
      } else {
        attrArr.push(attribute.attr);
      }
    });

    return attrArr;
  }, [language, attributesConfig]);

  return multilingualAttributes;
};

export default useMultilingualSearchableAttributes;
